import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation
} from "@angular/core";
import {ApiService} from "../../../../../../../../common/services/api.service";
import {Modal, ModalService} from "../../../../../../../services/modal.service";
import {OrderWizardItemReplenishmentComponent} from "../../../index";
import {ToastService} from "../../../../../../../../common/services/toast.service";
import {StorageService} from "../../../../../../../../common/services/storage.service";
import {OrderWizardItemsComponent} from "../items";
import {PusherService} from "../../../../../../../../common/services/pusher.service";
import {SpinnerService} from "../../../../../../../../common/services/spinner.service";
import {PartnerService} from "../../../../../../../../common/services/partner.service";
import {PartnerPartMasterService} from "../../../../../services/part-master.service";
import {Wizard} from "../../../../../../../../common/interfaces/wizard.interface";
import {Api3Service} from "../../../../../../../../common/services/api3.service";

@Component({
    selector: "section-order-wizard-items-replenishment",
    templateUrl: "../items.component.html",
    styleUrls: [
        "../items.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class OrderWizardItemsReplenishmentComponent extends OrderWizardItemsComponent implements OnChanges {

    public constructor(
        protected apiService: ApiService,
        protected api3Service: Api3Service,
        protected modalService: ModalService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected toastService: ToastService,
        protected storageService: StorageService,
        protected pusherService: PusherService,
        protected partMasterService: PartnerPartMasterService,
        protected spinnerService: SpinnerService
    ) {
        super(apiService, api3Service, modalService, changeDetectorRef, toastService,
            storageService, pusherService, partMasterService, spinnerService);
    }

    protected getDefaultInboundHubId(): number {
        const add_order_storage = this.storageService.get("add_order");
        if (add_order_storage && add_order_storage?.hub_id) {
            return add_order_storage?.hub_id;
        }
        if (this.address.inbound_inventory_conversions.length) {
            return this.address.inbound_inventory_conversions[0].id;
        }
        return super.getDefaultHubId();
    }

    protected setup(data: Wizard.IData): void {
        super.setup(data);

        this.prepareInboundTable();

    }

    /**
     * Add new item
     * @returns {void}
     */
    public async addItem(type: string = "inbound"): Promise<any> {

        const response: Modal.IResponse = await this.modalService.open(OrderWizardItemReplenishmentComponent, {
            partmasters: this.partmasters,
            details: this.details,
            order_id: this.data.order_id,
            serviceLevel: this.serviceLevel,
            state: this.state,
            modalWidth: "600px",
            default_inbound_hub_id: this.getDefaultInboundHubId(),
            disable_hub_select: PartnerService.partner.properties["lock_hub_in_order"]
        });
        if (response && response.value) {
            this.inboundTableRef.reload(this.getUrl("inbound"));
            this.changeDetectorRef.markForCheck();
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }
}
